import React, { useEffect, useRef, useState } from 'react';
import '../App.css';

const GUIDE_ITEMS = [
  {
    id: 'welcome',
    title: 'WhatsApp Asistanına Hoş Geldiniz',
    desc: 'Çocuğunuzla ilgili bilgileri WhatsApp üzerinden doğal bir cümleyle sorabilirsiniz. Başlamak için aşağıdaki örneklerden birini yazmanız yeterli.',
    examples: [
      { q: 'Bugün neleri sorabilirim?', a: 'Ödevler, ders programı, yoklama ve devamsızlık, değerlendirmeler, Mini Görevler, öğretmen bilgileri ve Öğrenci360 konusunda yardımcı olabilirim.' },
      { q: 'Sorumu nasıl yazmalıyım?', a: 'Günlük konuşur gibi yazın. Örneğin “Yusuf’un bugünkü ödevleri ne?” veya “Yarın Matematik var mı?” diyebilirsiniz.' }
    ]
  },
  {
    id: 'homework',
    title: 'Ödevleri Sorun',
    desc: 'Bugünün, yarının veya belirli bir dersin ödevini sorabilirsiniz.',
    examples: [
      { q: 'Bugünkü ödevler ne?', a: '📚 Yusuf için bugün paylaşılan ödevleri listelerim.' },
      { q: 'Matematik ödevi ne?', a: '📘 Sadece Matematik dersinin ödevini paylaşırım.' }
    ]
  },
  {
    id: 'schedule',
    title: 'Ders Programını Öğrenin',
    desc: 'Bugün, yarın veya belirli bir gündeki ders programını sorabilirsiniz.',
    examples: [
      { q: 'Yarın ders programı nasıl?', a: '🗓️ Yarınki ders saatlerini ve dersleri paylaşırım.' },
      { q: 'Pazartesi Türkçe dersi var mı?', a: '🗓️ Pazartesi günündeki Türkçe dersini kontrol ederim.' }
    ]
  },
  {
    id: 'attendance',
    title: 'Yoklama ve Devamsızlık',
    desc: 'Çocuğunuzun yoklama durumunu ve toplam devamsızlığını sorabilirsiniz.',
    examples: [
      { q: 'Yusuf bugün okulda mı?', a: '📋 Bugünkü yoklama kaydını kontrol ederim.' },
      { q: 'Toplam devamsızlık kaç gün?', a: '📘 Kayıtlı devamsızlık sayısını paylaşırım.' }
    ]
  },
  {
    id: 'assessments',
    title: 'Değerlendirme Sonuçları',
    desc: 'Ders değerlendirmesi, deneme ve hikâye kitabı değerlendirme sonuçlarını sorabilirsiniz.',
    examples: [
      { q: 'Son deneme sonucu nedir?', a: '🎯 Puanı, doğru-yanlış sayılarını ve ders bazındaki netleri paylaşırım.' },
      { q: 'Ders değerlendirmesi sonucu nedir?', a: '📊 Son ders değerlendirmesi sonucunu kontrol ederim.' }
    ]
  },
  {
    id: 'mini-tasks',
    title: 'Mini Görevleri Açın',
    desc: 'Öğretmeninizin paylaştığı Mini Görevlere WhatsApp üzerinden ulaşabilirsiniz. Çocuğunuz görevi açıp tamamladığında ilerlemesi takip edilir.',
    examples: [
      { q: 'mini görev', a: '🎯 Size özel ve süreli Mini Görev bağlantınızı gönderirim.' },
      { q: 'WhatsApp’taki “Mini Görev” düğmesine dokunun', a: '🧠 Çocuğunuzun Mini Görev ekranı açılır.' }
    ]
  },
  {
    id: 'student360',
    title: 'Öğrenci360 ile Ayrıntıları Görün',
    desc: 'Daha ayrıntılı gelişim, çalışma ve değerlendirme kayıtları için Öğrenci360 bağlantısı isteyebilirsiniz.',
    examples: [
      { q: 'öğrenci360', a: '🔐 Size özel ve süreli Öğrenci360 bağlantınızı gönderirim.' },
      { q: 'Öğrencimin gelişimini nereden görebilirim?', a: '👤 Ayrıntılı takip için “öğrenci360” yazmanızı isterim.' }
    ]
  },
  {
    id: 'study-form',
    title: 'Çalışma Formunu Kullanın',
    desc: 'Size gelen günlük çalışma hatırlatmasındaki “Çalışmayı Ekle” düğmesiyle soru sayısı, okunan sayfa ve tamamlanan kitap bilgisini kolayca kaydedebilirsiniz.',
    examples: [
      { q: 'WhatsApp’taki “Çalışmayı Ekle” düğmesine dokunun', a: '📝 Günlük çalışma formu açılır. Derslere göre soru sayılarını ve okunan sayfaları seçebilirsiniz.' },
      { q: 'Formu gönderin', a: '✅ Çalışma kaydı öğrenci gelişim özetine yansır.' }
    ]
  },
  {
    id: 'teachers',
    title: 'Öğretmen Bilgileri',
    desc: 'Ders öğretmenini veya paylaşılan öğretmen listesini sorabilirsiniz.',
    examples: [
      { q: 'Matematik öğretmeni kim?', a: '👩‍🏫 Matematik öğretmeni bilgisini paylaşırım.' },
      { q: 'Öğretmen listesini getir', a: '👩‍🏫 Paylaşılan ders ve öğretmen listesini gösteririm.' }
    ]
  },
  {
    id: 'multiple-children',
    title: 'Birden Fazla Çocuğunuz Varsa',
    desc: 'Mesajınızda öğrencinin adını yazmanız, doğru bilgiye daha hızlı ulaşmanızı sağlar.',
    examples: [
      { q: 'Zeynep’in bugünkü ödevleri ne?', a: '✅ Zeynep için ödevleri paylaşırım.' },
      { q: 'Ahmet’in son deneme sonucu nedir?', a: '✅ Ahmet için son deneme sonucunu kontrol ederim.' }
    ]
  },
  {
    id: 'quick-help',
    title: 'Kısa Bir İpucu',
    desc: 'Aradığınız bilgiyi tek cümleyle yazın. Mesajınızda çocuğunuzun adını ve öğrenmek istediğiniz konuyu belirtmeniz yeterlidir.',
    examples: [
      { q: 'Zeynep’in yarınki dersleri ne?', a: 'Bu şekilde yazdığınızda doğru öğrenci ve doğru gün için hızlıca yardımcı olurum.' },
      { q: 'Başka neler yapabilirsin?', a: 'Ödevler, ders programı, yoklama, değerlendirmeler, öğretmen bilgileri ve Öğrenci360 konusunda yardımcı olabilirim.' }
    ]
  }
];

export default function ParentGuidePage() {
  const slidesRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [hasInteracted, setHasInteracted] = useState(false);
  const total = GUIDE_ITEMS.length;

  const getSlideWidth = () => {
    const scroller = slidesRef.current;
    if (!scroller) return 0;
    const first = scroller.querySelector('.feature-slide');
    return first ? first.clientWidth + 18 : scroller.clientWidth;
  };

  const scrollToIndex = (nextIndex) => {
    const scroller = slidesRef.current;
    if (!scroller) return;
    const target = ((nextIndex % total) + total) % total;
    scroller.scrollTo({ left: target * getSlideWidth(), behavior: 'smooth' });
    setHasInteracted(true);
  };

  useEffect(() => {
    const scroller = slidesRef.current;
    if (!scroller) return undefined;
    const onScroll = () => {
      const width = getSlideWidth();
      if (!width) return;
      setIndex(Math.max(0, Math.min(total - 1, Math.round(scroller.scrollLeft / width))));
      if (!hasInteracted && scroller.scrollLeft > 2) setHasInteracted(true);
    };
    scroller.addEventListener('scroll', onScroll, { passive: true });
    return () => scroller.removeEventListener('scroll', onScroll);
  }, [hasInteracted, total]);

  useEffect(() => {
    const onResize = () => {
      const scroller = slidesRef.current;
      const width = getSlideWidth();
      if (scroller && width) setIndex(Math.round(scroller.scrollLeft / width));
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const scroller = slidesRef.current;
    if (!scroller) return undefined;
    const timer = setTimeout(() => {
      try { scroller.focus({ preventScroll: true }); } catch { scroller.focus(); }
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  const onKey = (event) => {
    if (event.key === 'ArrowRight') { event.preventDefault(); scrollToIndex(index + 1); }
    if (event.key === 'ArrowLeft') { event.preventDefault(); scrollToIndex(index - 1); }
  };

  return (
    <div className="site">
      <section className="section pres-spotlight" style={{ paddingTop: 56, paddingBottom: 56, minHeight: '100vh' }}>
        <div className="container" style={{ maxWidth: 1100 }}>
          <div className="feature-carousel" aria-roledescription="carousel">
            <div className="feature-carousel-header">
              <div className="muted" style={{ fontSize: 14 }}>WhatsApp kullanım rehberi</div>
              <div className="feature-controls">
                <button type="button" className="feature-btn" onClick={() => scrollToIndex(index - 1)} aria-label="Önceki bölüm">←</button>
                <div className="feature-index" aria-live="polite">{index + 1} / {total}</div>
                <button type="button" className="feature-btn" onClick={() => scrollToIndex(index + 1)} aria-label="Sonraki bölüm">→</button>
              </div>
            </div>
            <div
              className="feature-slides"
              ref={slidesRef}
              role="group"
              tabIndex={0}
              onKeyDown={onKey}
              aria-label="WhatsApp kullanım rehberi bölümleri"
              onMouseDown={() => setHasInteracted(true)}
              onTouchStart={() => setHasInteracted(true)}
            >
              {GUIDE_ITEMS.map((item, itemIndex) => (
                <article key={item.id} id={`guide-${item.id}`} className={`feature-slide ${itemIndex === index ? 'active' : ''}`}>
                  <div style={{ padding: '0 6px 6px' }}>
                    <h2 style={{ marginTop: 0 }}>{item.title}</h2>
                    <p className="muted" style={{ fontSize: 16, lineHeight: 1.55 }}>{item.desc}</p>
                    <div className="feature-examples" style={{ marginTop: 18 }}>
                      {item.examples.map((example, exampleIndex) => (
                        <div key={exampleIndex} className="card" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: '.6px', color: '#42536a' }}>ÖRNEK #{exampleIndex + 1}</div>
                          <div className="chat-bubble parent" style={{ position: 'relative', margin: 0, background: '#e5f2ec' }}>Siz: {example.q}</div>
                          <div className="chat-bubble you" style={{ position: 'relative', margin: 0, background: '#f1f5fa', whiteSpace: 'pre-line' }}>Asistan: {example.a}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </article>
              ))}
              {!hasInteracted && index === 0 && <div className="drag-hint" aria-hidden="true">← Kaydırarak devam edin →</div>}
            </div>
            <div className="feature-edge feature-edge-left" aria-hidden="true" />
            <div className="feature-edge feature-edge-right" aria-hidden="true" />
            <div className="feature-dots" role="tablist" aria-label="Rehber bölümü seçimi">
              {GUIDE_ITEMS.map((item, itemIndex) => (
                <button
                  key={item.id}
                  className={`feature-dot ${itemIndex === index ? 'active' : ''}`}
                  aria-label={`${itemIndex + 1}. bölüm`}
                  aria-selected={itemIndex === index}
                  role="tab"
                  onClick={() => scrollToIndex(itemIndex)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
